import React, { Fragment, useState, useEffect } from "react";
import Slider, { Range } from "rc-slider";
import "rc-slider/assets/index.css";

const GPASlider = ({ handleGPASlider, minGPA, maxGPA }) => {
  const marks = {
    0: {
      style: {
        width: "10px",
      },
      label: "0",
    },
    0.5: {
      style: {
        width: "15px",
      },
      label: "0.5",
    },
    1: {
      style: {
        width: "20px",
      },
      label: "1",
    },
    1.5: {
      style: {
        width: "25px",
      },
      label: "1.5",
    },
    2: {
      style: {
        width: "30px",
      },
      label: "2",
    },
    2.5: {
      style: {
        width: "35px",
      },
      label: "2.5",
    },
    3: {
      style: {
        width: "40px",
      },
      label: "3",
    },
    3.5: {
      style: {
        width: "45px",
      },
      label: "3.5",
    },
    4: {
      style: {
        width: "50px",
      },
      label: "4",
    },
  };

  return (
    <Fragment>
      <div style={{ width: "100%", marginTop: "0px" }}>
        <div className="query-title-containers ">
          <p style={{ marginBottom: "10px" }} className="bold">{`GPA Range`}</p>
        </div>
        <div
          className="col-md-12 row flex"
          style={{ margin: "0", alignItems: "center", padding: "10px 0" }}
        >
          <div className="col-md-6" style={{ paddingRight: "20px" }}>
            <Range
              step={0.5}
              defaultValue={[minGPA, maxGPA]}
              marks={marks}
              min={0}
              max={4}
              tipFormatter={(value) => <span className="tooltip">{value}</span>}
              activeDotStyle={{ borderColor: "#009900" }}
              dotStyle={{ borderColor: "#e0e0e0" }}
              onChange={(value) => handleGPASlider(value)}
            />
          </div>
          <div
            style={{ justifyContent: "space-evenly", alignItems: "center" }}
            className="col-md-6 flex"
          >
            <div className="gpa-display-box">
              <p className="gpa-label">Minimum GPA</p>
              <p className="gpa-value">{minGPA}</p>
            </div>
            <div className="gpa-to-text">To</div>
            <div className="gpa-display-box">
              <p className="gpa-label">Maximum GPA</p>
              <p className="gpa-value">{maxGPA}</p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default GPASlider;
